import { FormLabel, OutlinedInput, styled } from '@mui/material';

export const StyledOutlinedInput = styled(OutlinedInput)(({ theme }) => ({
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    borderColor: `${theme.hhglobal.purpose.strokeStrong} !important`,
  },
}));

export const StyledFormLabel = styled(FormLabel)(({ theme }) => ({
  fontSize: '12px',
  fontWeight: theme.hhglobal.typography.fontWeights.regular,
  lineHeight: '16px',
  textTransform: 'uppercase',
  color: '#4D4D4D',
  '&.Mui-focused': { color: '#4D4D4D' },
  '&.Mui-error': { color: '#4D4D4D' },
  '& .MuiFormLabel-asterisk': { color: theme.hhglobal.utility.error[800] },
})) as typeof FormLabel;
